import React from 'react';
import {
  BanknotesIcon,
  ShoppingBagIcon,
  CursorArrowRaysIcon,
  CalculatorIcon,
  ReceiptPercentIcon,
  HandThumbUpIcon,
  ArrowUturnLeftIcon,
  CurrencyDollarIcon,
} from '@heroicons/react/24/outline';
import { Tooltip } from 'react-tooltip';
import { StatCard } from '../../../components/ui';
import { formatCurrency } from '../../../utils/baseUtils';

export default function KpiGrid({ info, clickCountLoading }) {
  const avg = info.orderCount > 0 ? info.orderTotal / info.orderCount : 0;

  const tiles = [
    {
      label: 'Gross Sales',
      value: formatCurrency(info.orderTotal),
      icon: BanknotesIcon,
      tone: 'emerald',
      tooltip:
        'Total amount collected from customers before any refunds, cancellations, card processing fees, platform fees, etc.',
    },
    {
      label: 'Order Volume',
      value: Number(info.orderCount || 0).toLocaleString('en-US'),
      icon: ShoppingBagIcon,
      tone: 'blue',
      tooltip: 'Number of completed orders.',
    },
    {
      label: 'Kiosk Interactions',
      value: Number(info.clickCount || 0).toLocaleString('en-US'),
      icon: CursorArrowRaysIcon,
      tone: 'amber',
      loading: clickCountLoading,
      tooltip:
        'Total kiosk sessions, including sessions that did not result in a completed order.',
    },
    {
      label: 'Avg. Ticket Size',
      value: formatCurrency(avg),
      icon: CalculatorIcon,
      tone: 'blue',
      tooltip: 'Average sales amount per completed order.',
    },
    {
      label: 'Sales Tax',
      value: formatCurrency(info.tax),
      icon: ReceiptPercentIcon,
      tone: 'blue',
      tooltip: 'Total sales tax collected from customers.',
    },
    {
      label: 'Tip',
      value: formatCurrency(info.tip),
      icon: HandThumbUpIcon,
      tone: 'emerald',
      tooltip: 'Total tips collected from customers.',
    },
    {
      label: 'Refunds',
      value: formatCurrency(info.refund),
      icon: ArrowUturnLeftIcon,
      tone: 'rose',
      tooltip: 'Total amount refunded to customers.',
    },
    {
      label: 'Net Payout',
      value: formatCurrency(info.payout),
      icon: CurrencyDollarIcon,
      tone: 'emerald',
      tooltip:
        'Estimated amount payable to the restaurant after refunds, processing fees, platform fees, and other adjustments.',
    },
  ];

  return (
    <>
      <Tooltip
        id="report-store-kpi-tooltip"
        place="top"
        positionStrategy="fixed"
        opacity={1}
        style={{ zIndex: 9999 }}
        className="!max-w-[18rem] !rounded-lg !border !border-slate-200 !bg-white !px-3 !py-2.5 !text-xs !font-medium !leading-snug !text-slate-700 !shadow-[0_10px_25px_-5px_rgba(15,23,42,0.12),0_4px_10px_-3px_rgba(15,23,42,0.08)] dark:!border-slate-700 dark:!bg-slate-900 dark:!text-slate-200"
      />
      <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
        {tiles.map((tile, index) => (
          <StatCard
            key={tile.label}
            icon={tile.icon}
            label={tile.label}
            uppercaseLabel={false}
            value={tile.value}
            tone={tile.tone}
            loading={tile.loading}
            tooltip={tile.tooltip}
            tooltipId="report-store-kpi-tooltip"
            style={{ animationDelay: `${index * 50}ms` }}
          />
        ))}
      </div>
    </>
  );
}
